import { render, staticRenderFns } from "./PeriodDiffIcon.vue?vue&type=template&id=be96b02c&scoped=true"
import script from "./PeriodDiffIcon.vue?vue&type=script&lang=js"
export * from "./PeriodDiffIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be96b02c",
  null
  
)

export default component.exports